import InvoiceView from '../components/invoice/InvoiceView';

export default function InvoiceViewPage({ activeInvoice, saleDocumentTitle, onEdit, onBack, onDownload, onDelete, onDeleteSubInvoice, onDeleteAllSubInvoices }) {
  return (
    <InvoiceView
      invoice={activeInvoice}
      saleDocumentTitle={saleDocumentTitle}
      onEdit={onEdit}
      onBack={onBack}
      onDownload={onDownload}
      onDelete={onDelete}
      onDeleteSubInvoice={onDeleteSubInvoice}
      onDeleteAllSubInvoices={onDeleteAllSubInvoices}
    />
  );
}


